import { render, staticRenderFns } from "./TeamBoardContent.vue?vue&type=template&id=37ae5198&"
import script from "./TeamBoardContent.vue?vue&type=script&lang=ts&"
export * from "./TeamBoardContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports